/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_UpdatedInputs */



/**
* | output |
* | --- |
* | "Caption position updated" |
*
* @param {Caption_Position_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_updated = /** @type {((inputs?: Caption_Position_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position des sous-titres mise à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriftenposition aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione didascalia aggiornata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция подписи обновлена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición de subtítulo actualizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题位置已更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション位置を更新しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन स्थिति अपडेट की गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição da legenda atualizada")
	return /** @type {LocalizedString} */ ("Caption position updated")
});